<div class="services-grid">

    <services-card *ngFor="let service of services" 
        [serviceHeading]="service.serviceHeading" 
        [servicePictureUrl]="service.servicePictureUrl" 
        [serviceDescription]="service.serviceDescription">
    </services-card>

</div>